'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactIntl = require('react-intl');

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _Progress = require('web-makeup/dist/Progress');

var _Progress2 = _interopRequireDefault(_Progress);

var _TextComponents = require('../TextComponents');

var _style = require('../style');

var _hooks = require('../hooks');

var _LoadingIndicator = require('./LoadingIndicator.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LoadingIndicator = function LoadingIndicator() {
    var EXPECTED_LOADING_TIME = 10;
    var STEP_SHOWING_TIME = 3;
    var MAX_PROGRESS = 98;
    var UPDATE_PER_SECOND = 5;
    var INTERVAL = 1000 / UPDATE_PER_SECOND;
    var PROGRESS_INCREASE_PER_SECONDS = Math.floor(MAX_PROGRESS / EXPECTED_LOADING_TIME) / UPDATE_PER_SECOND;
    var _a = React.useState(0),
        progress = _a[0],
        setProgress = _a[1];
    var _b = React.useState(0),
        stepIndex = _b[0],
        setStepIndex = _b[1];
    (0, _hooks.useInterval)(function () {
        setProgress(progress + PROGRESS_INCREASE_PER_SECONDS);
        var elapsedTime = progress / PROGRESS_INCREASE_PER_SECONDS / UPDATE_PER_SECOND;
        var newStepIndex = Math.floor(elapsedTime / STEP_SHOWING_TIME % LOADING_STEPS.length);
        setStepIndex(newStepIndex);
    }, INTERVAL, true);
    var LOADING_STEPS = [{
        icon: 'icon-loading-1',
        textId: 'payment_loading.step_1'
    }, {
        icon: 'icon-loading-2',
        textId: 'payment_loading.step_2'
    }, {
        icon: 'icon-loading-3',
        textId: 'payment_loading.step_3'
    }];
    return React.createElement(_LoadingIndicator.Container, null, React.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: { id: '/v1/-logos-2019/logo-big-black', type: 'upload' } }), React.createElement(_TextComponents.Text, { size: "2rem", fontWeight: "900", lineHeight: "2.5rem", color: _style.COLOR_MIDNIGHT, margin: "2rem 0 1rem", textAlign: "center" }, React.createElement(_reactIntl.FormattedMessage, { id: "payment_loading.title" })), React.createElement(_TextComponents.ChildText, { textAlign: "center" }, React.createElement(_reactIntl.FormattedMessage, { id: "payment_loading.description" })), React.createElement(_LoadingIndicator.LoadingContainer, null, React.createElement(_LoadingIndicator.IconContainer, null, React.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: {
            id: "/v1/-icons-browse-order-deliver/-order/-configure/" + LOADING_STEPS[stepIndex].icon,
            type: 'upload'
        } })), React.createElement(_TextComponents.ChildText, { textAlign: "center", margin: "1.5rem 0 0", size: "14px" }, React.createElement(_reactIntl.FormattedMessage, { id: LOADING_STEPS[stepIndex].textId })), React.createElement(_LoadingIndicator.ProgressContainer, null, React.createElement(_Progress2.default, { size: "small", percent: progress, showInfo: false, type: "line", strokeWidth: 5, strokeColor: "black" }))));
};
exports.default = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/LoadingIndicator/LoadingIndicator.js
// module id = 1933
// module chunks = 0